import E from 'wangeditor'

const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } = E

// let isHtml = false

class htmlMenu extends BtnMenu {
  notHtml = true
  constructor(editor) {
    const $elem = E.$(
      `<div class="w-e-menu" data-title="HTML">
      HTML
      </div>`
    )
    super($elem, editor)
  }

  clickHandler(e) {
    this.editor.txt.html(this.editor.editorVal)
    const el = e.target.parentNode.parentNode.parentNode.lastChild
    if (this.notHtml) {
      this.notHtml = false
      el.style.zIndex = 1
      this.editor.toggle = 1
    } else {
      this.notHtml = true
      el.style.zIndex = 0
      this.editor.toggle = 0
    }
  }

  tryChangeActive() {
    this.active()
  }
}

export default htmlMenu
